// extracted by mini-css-extract-plugin
export default {"container":"dSuPwq","recording":"H23uAP","recordingText":"hIlARj","left":"beDXdp","right":"EdvPmR","controlButtonText":"sDwbDr"};